export default __webpack_public_path__ + "static/skylinePdf-a2aba131fce4fd8e5e48223f53c4c77b.png";